<template>
    <div :class="isMobile?'container-mobile':'container'">
        <v-alert
            v-for="(item, index) in filteredNotifications"
                :key="index"
                :value="true"
                :color="getColor(item)"
                :icon="item.icon"
                outline
                class="rounded-4"
        >
             <v-chip
                v-if="item.recipient"
                small
                outlined
                :class="isMobile?'recipient-chip-mobile':'recipient-chip'"
                dark
            >
                To: {{ item.recipient }}
            </v-chip>
  
            <div @click="showDetails(item.detailsLink)" :class="item.detailsLink?'header-clickable':''" :title="item.detailsLink?'Click to view details':''">
                <strong>{{ item.typeName }}</strong>
                <span v-if="item.detailsLink">&nbsp;<v-icon small>open_in_new</v-icon></span>
            </div>
            <div v-if="item.displayDuration" class="details-section">
                <b>{{ formatSchedule(item) }}</b>
            </div>
            <div class="details-section" v-html="item.details"></div>
        </v-alert>
     </div>
</template>

<script>
import publicNotificationsApi from '@/api/publicnotification'
import { hasEditRights } from '@/helpers/access-permissions'

export default {
    data() {
        return {
            notifications: [],
            error: false,
            errorMessage: null,
        }
    },
    methods: {
        showDetails(link) {
            if (link) window.open(link)
        },
        async getNowShowing() {
            try {
                // Load cached data first for fast UI
                const cachedData = localStorage.getItem('publicNotifications')
                if (cachedData) {
                    this.notifications = JSON.parse(cachedData)
                }

                // Fetch latest data
                const response = await publicNotificationsApi.getNowShowing()
                if (response && response.status === 200 && response.data.nowShowing) {
                    this.notifications = response.data.nowShowing
                    localStorage.setItem('publicNotifications', JSON.stringify(this.notifications))
                }
            } catch (error) {
                this.error = true
                this.errorMessage = error.message || error
            }
        },
        formatSchedule(data) {
            const start = this.$moment(data.effectiveDate)
            const end = this.$moment(data.expirationDate)
            const today = this.$moment()

            const startDateLabel = today.isSame(start, 'day')
                ? `Today (${start.format('ddd')})`
                : start.format('MMM D (ddd)')

            const endDateLabel = today.isSame(end, 'day')
                ? `Today (${end.format('ddd')})`
                : end.format('MMM D (ddd)')

            // If start and end are the same day
            if (start.isSame(end, 'day')) {
                return `${startDateLabel} from ${start.format('h:mm A')} to ${end.format('h:mm A')}`
            }

            // If start and end are different days
            return `${startDateLabel} ${start.format('h:mm A')} to ${endDateLabel} ${end.format('h:mm A')}`
        },
        getColor(item) {
            // If API gives hex code, use it; otherwise fallback to Vuetify color name
            if (item.backgroundColor && item.backgroundColor.startsWith('#')) {
                return item.backgroundColor
            }
            return item.backgroundColor || 'primary'
        }
    },
    created() {
        this.getNowShowing()
    },
    computed: {
        filteredNotifications() {
            return this.notifications.filter(item => {
                if (item.recipient === 'All Users') {
                    return true
                }
                if (item.recipient === 'HR Admin') {
                    return this.isHRAdmin
                }
                if (item.recipient === 'Compensation Admin') {
                    return this.isCompensationAdmin
                }
                if (item.recipient === 'Payroll Admin') {
                    return this.isPayrollAdmin
                }
                return false
            })
        },
        isHRAdmin() {
            const routerEmployees = this.$router.resolve({ name: 'Employees' })
            const routerHolidays = this.$router.resolve({ name: 'HolidaysMain' })
            const routerCalendarPeriods = this.$router.resolve({ name: 'CalendarPeriods' })

            return hasEditRights(routerEmployees.route.fullPath) ||
                    hasEditRights(routerHolidays.route.fullPath) ||
                    hasEditRights(routerCalendarPeriods.route.fullPath)
        },
        isCompensationAdmin() {
             const routerCompBen = this.$router.resolve({ name: 'AllocationMain' })
             return hasEditRights(routerCompBen.route.fullPath)
        },
        isPayrollAdmin() {
            const routerPayroll = this.$router.resolve({ name: 'PayrollGenerate' })
            return hasEditRights(routerPayroll.route.fullPath)
        }
    },
}
</script>
<style scoped>
.container {
    width: 90%; 
    height: 90%; 
    margin-top:50px;
}
.container-mobile {
    width: 100%; 
    height: 100%; 
    margin-top:10px;
}
.header-clickable {
    text-decoration: underline;
    cursor: pointer;
}
.recipient-chip {
    position: absolute;
    top: 8px;
    right: 5px;
    font-size: 10px;
}
.recipient-chip-mobile {
    margin-left:0px;
    font-size: 10px;
}
.details-section {
    color: #3b3b3b;
}
</style>
